import Main from "./components/Main";
import Menu from "./components/Menu";
import PPVAlert from "./components/PPVAlert";

function App() {
  return (
    <>
      <PPVAlert />
      <Menu />
      <Main />
    </>
  );
}

export default App;
